import { FRAME_THEME_COLOR } from '@nandosaus/constants';
import { observer } from 'mobx-react';
import { useRootStore } from '@nandosaus/state-management';
import PropTypes from 'prop-types';

import { withAppProps } from '@utils/with-app-props';
import { Alert } from '../../components/alert';
import { BackgroundFrame } from '../../components/frames/background-frame';
import { Col, Container, Row } from '../../components/grid';
import { ForgotPasswordForm } from '../../components/forgot-password-form';
import { Layout } from '../../components/layout';
import { useRedirectIfAuthenticated } from '../../hooks/useRedirectIfAuthenticated';

const ForgotPassword = ({ title }) => {
  useRedirectIfAuthenticated();

  const { CartStore } = useRootStore();

  const { TEAL } = FRAME_THEME_COLOR;

  return (
    <Layout title={title}>
      <BackgroundFrame showFireIcon showTopBar={false} variant={TEAL}>
        <Container>
          <Row mt={4} mb={3}>
            <Col width={{ xs: 12 / 12, lg: 6 / 12 }} offset={[0, 0, 0, 3 / 12]}>
              <ForgotPasswordForm />
              {CartStore.isDineIn && (
                <Alert heading="Having trouble placing an order?" type="info" mt={1}>
                  No problem, head to the front counter and we&apos;ll put your order through
                </Alert>
              )}
            </Col>
          </Row>
        </Container>
      </BackgroundFrame>
    </Layout>
  );
};

ForgotPassword.propTypes = {
  title: PropTypes.string,
};

ForgotPassword.defaultProps = {
  title: undefined,
};

export const getStaticProps = withAppProps(async () => {
  return {
    props: {
      title: 'Forgot Password',
    },
  };
});

export default observer(ForgotPassword);
